<template>
<router-link :to="'/profile/' + who.id">{{ who | name }}</router-link>
</template>

<script>
import base from 'base.vue'

export default {
    mixins: [ base ],
    props: [ 'who' ],
}
</script>



// WEBPACK FOOTER //
// user-link.vue?36143bf8